export const defaultFilter = { filter: { order: ['id ASC'] } };
export const API_URL = 'https://api.code4change.dev';
export const DOMAIN = 'https://code4change.dev';
